var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgReply = function SvgReply(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "M11 13.579a.75.75 0 0 0 0 1.5v-1.5ZM21 20l-.683.31A.75.75 0 0 0 21.75 20H21ZM11 7.702h-.75a.75.75 0 0 0 .7.748l.05-.748ZM11 3h.75a.75.75 0 0 0-1.28-.53L11 3Zm-8 8-.53-.53a.75.75 0 0 0 0 1.06L3 11Zm8 8-.53.53a.75.75 0 0 0 1.28-.53H11Zm.75-4.667a.75.75 0 0 0-1.5 0h1.5Zm-.75.746c4.36 0 7.96 2.241 9.317 5.23l1.366-.619C20.037 16.064 15.828 13.58 11 13.58v1.5ZM21.75 20v-1.007h-1.5V20h1.5Zm0-1.007c0-6.376-4.694-11.643-10.7-12.04l-.1 1.497c5.152.34 9.3 4.887 9.3 10.543h1.5Zm-10-11.291V3h-1.5v4.702h1.5ZM10.47 2.47l-8 8 1.06 1.06 8-8-1.06-1.06Zm-8 9.06 8 8 1.06-1.06-8-8-1.06 1.06ZM11.75 19v-4.667h-1.5V19h1.5Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReply);
export default ForwardRef;